import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseTopic, RTopic} from './topicModel';

/*
 * Runtime type.
 */

const RSearchTopicDirty = t.readonly(
  t.type({
    topic: t.union([RTopic, t.undefined]),
  }),
);

/*
 * Type.
 */

export interface SearchTopicModel extends t.TypeOf<typeof RSearchTopicDirty> {}
export const RSearchTopic = t.clean<SearchTopicModel>(RSearchTopicDirty as any);

/*
 * IO methods.
 */

export function parseSearchTopic(src: any): SearchTopicModel {
  return {
    topic: src.matching_topic ? parseTopic(src.matching_topic) : undefined,
  };
}

/*
 * API type.
 */

export const ApiSearchTopic = makeApiType('searchTopic', RSearchTopic, parseSearchTopic);
